import { Amplify } from 'aws-amplify';
import { signOut } from 'aws-amplify/auth';
import { LoginResponseType } from '../../types';

// 設定
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID!,
      userPoolClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID!
    }
  }
});

export const signout = async (): Promise<LoginResponseType> => {
  try {
    await signOut();
    return {
      statusCode: 200,
      message: 'ログアウトに成功しました',
      mailAddress: '',
      accessToken: ''
    };
  } catch (error) {
    console.log(error);
    return {
      statusCode: 400,
      message: 'ログアウトに失敗しました',
      mailAddress: '',
      accessToken: ''
    };
  }
};
